const { createAction } = require("@reduxjs/toolkit");

export const setFilter = createAction("FILTER")